import { Action } from 'redux'
import { isType } from 'ts-action'
import { IUpshifterPunchCardsReducer } from 'models/PunchCard'
import {
  GetPunchCards,
  GetPunchCardsErrors,
  PunchCardsFetching,
  ClearPunchCards,
} from './actions'

const initialState: IUpshifterPunchCardsReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const punchCardsReducer = (
  state = initialState,
  action: Action,
): IUpshifterPunchCardsReducer => {
  if (isType(action, GetPunchCards)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, GetPunchCardsErrors)) {
    const { payload } = action
    return {
      ...state,
      error: {
        code: payload.code,
        message: payload.message,
      },
    }
  }

  if (isType(action, PunchCardsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }

  if (isType(action, ClearPunchCards)) {
    return initialState
  }

  return state
}
